module.exports = __webpack_public_path__ + "static/media/industryplus_white.7f7c2c28.svg";